import { Button } from "@/components/ui/baseUi/button"
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/baseUi/dialog"
import { WarningHexagonalIcon } from "@images/svgIcons/warningIcon"
import { word } from "@modules/core/utils/i18n"
import { useTaxes } from "@modules/finances/taxes/hooks/useTaxes"
import { CheckIcon, LoaderCircle } from "lucide-react"
import { Text } from "@/components/ui/baseUi/text"

export const ActivateTaxSettingsDialog = ({}: {}) => {
  const { activateTaxDialogVisible, setActivateTaxDialogVisible, isPendingActivateTaxes, handleActivateTaxSettings } =
    useTaxes()

  return (
    <Dialog open={activateTaxDialogVisible} onOpenChange={setActivateTaxDialogVisible}>
      <DialogContent className="w-175 p-0">
        <DialogHeader>
          <DialogTitle
            className="flex items-center justify-start border-b border-neutral-200 p-6"
            style={{ height: 70 }}
          >
            <Text fontStyle="TL">{word("finances.taxes.dialog.activate.title")}</Text>
          </DialogTitle>
        </DialogHeader>

        <div className="flex flex-col gap-4 px-8 py-4">
          <div className="flex flex-col">
            <Text fontStyle="LM">{word("finances.taxes.dialog.activate.description1")}</Text>
            <Text fontStyle="LM">{word("finances.taxes.dialog.activate.description2")}</Text>
          </div>
          <div className="flex flex-row items-center gap-3 rounded-md bg-(--card-background) p-3">
            <div className="flex">
              <WarningHexagonalIcon color={"var(--primary-300)"} width={18} height={18} />
            </div>
            <Text fontStyle="BM">{word("finances.taxes.dialog.activate.informations")}</Text>
          </div>
        </div>

        <DialogFooter className="px-8 pb-8">
          <div className="flex justify-end gap-4">
            <Button variant="outline" size="lg" onClick={() => setActivateTaxDialogVisible(false)}>
              {word("global.cancel")}
            </Button>
            <Button
              isLoading={isPendingActivateTaxes}
              variant="primary"
              size="lg"
              onClick={handleActivateTaxSettings}
              disabled={isPendingActivateTaxes}
            >
              {isPendingActivateTaxes ? <LoaderCircle className="animate-spin" /> : <CheckIcon color="currentColor" />}
              {word("finances.taxes.dialog.activate.button")}
            </Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
